import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const api = {
  spaces: () => axios.get(`${API}/spaces`).then((r) => r.data),
  stats: () => axios.get(`${API}/stats`).then((r) => r.data),
  logs: () => axios.get(`${API}/logs`).then((r) => r.data),
  checkin: (body) => axios.post(`${API}/checkin`, body).then((r) => r.data),
  checkout: (n) => axios.post(`${API}/checkout/${n}`).then((r) => r.data),
  reserve: (body) => axios.post(`${API}/reserve`, body).then((r) => r.data),
  release: (n) => axios.post(`${API}/release/${n}`).then((r) => r.data),
  assign: (body) => axios.post(`${API}/assign`, body).then((r) => r.data),
  unassign: (n) => axios.post(`${API}/unassign/${n}`).then((r) => r.data),
  capacity: () => axios.get(`${API}/capacity`).then((r) => r.data),
  setCapacity: (total) => axios.put(`${API}/capacity`, { total }).then((r) => r.data),
  setZone: (body) => axios.put(`${API}/zones`, body).then((r) => r.data),
};

const AUTH = `${process.env.REACT_APP_BACKEND_URL}/api/auth`;

export const authApi = {
  me: () => axios.get(`${AUTH}/me`).then((r) => r.data),
  login: (body) => axios.post(`${AUTH}/login`, body).then((r) => r.data),
  register: (body) => axios.post(`${AUTH}/register`, body).then((r) => r.data),
  logout: () => axios.post(`${AUTH}/logout`).then((r) => r.data),
  forgotPassword: (email) => axios.post(`${AUTH}/forgot-password`, { email }).then((r) => r.data),
  resetPassword: (body) => axios.post(`${AUTH}/reset-password`, body).then((r) => r.data),
  changePassword: (body) => axios.post(`${AUTH}/change-password`, body).then((r) => r.data),
  users: () => axios.get(`${AUTH}/users`).then((r) => r.data),
  deleteUser: (id) => axios.delete(`${AUTH}/users/${id}`).then((r) => r.data),
  setApproval: (id, approved) => axios.post(`${AUTH}/users/${id}/approval`, { approved }).then((r) => r.data),
};

export const errMsg = (e) => formatApiErrorDetail(e?.response?.data?.detail) || e?.message;
